export const footerMoreLinks = {
  'au-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://au.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://au.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },
        {
          href: 'https://au.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://au.wingie.com/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://au.wingie.com/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://au.wingie.com/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'au-en': [
    {
      title: 'More',
      items: [
        { title: 'Contact', href: 'https://au.wingie.com/contact/' },
        {
          title: 'Frequently Asked Questions',
          href: 'https://au.wingie.com/faq/',
        },
        { title: 'About us', href: 'https://au.wingie.com/about-us/' },
        { title: 'Privacy', href: 'https://au.wingie.com/privacy/' },
        {
          title: 'Terms and Conditions',
          href: 'https://au.wingie.com/terms-and-conditions/',
        },
        {
          href: 'https://au.wingie.com/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'au-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://au.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://au.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },
        {
          href: 'https://au.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://au.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://au.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://au.wingie.com/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'au-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://au.wingie.com/ar/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://au.wingie.com/ar/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://au.wingie.com/ar/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://au.wingie.com/ar/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://au.wingie.com/ar/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://au.wingie.com/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'au-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://au.wingie.com/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://au.wingie.com/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },
        {
          href: 'https://au.wingie.com/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://au.wingie.com/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://au.wingie.com/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://au.wingie.com/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'au-it': [
    {
      title: 'Di più',
      items: [
        { href: 'https://au.wingie.com/it/contact/', title: 'Contatti' },
        // { href: 'https://au.wingie.com/it/faq/', title: 'Domande frequenti' },
        { href: 'https://au.wingie.com/it/about-us/', title: 'Chi siamo' },
        { href: 'https://au.wingie.com/it/privacy/', title: 'Privacy' },
        { href: 'https://au.wingie.com/it/terms-and-conditions/', title: 'Termini e condizioni' },
        {
          href: 'https://au.wingie.com/it/awards/',
          title: 'I nostri premi',
        },
      ],
    },
  ],
  'au-fr': [
    {
      title: 'Plus',
      items: [
        { href: 'https://au.wingie.com/fr/contact/', title: 'Contact' },
        // { href: 'https://au.wingie.com/fr/faq/', title: 'Questions fréquemment posées' },
        { href: 'https://au.wingie.com/fr/about-us/', title: 'À propos de nous' },
        { href: 'https://au.wingie.com/fr/privacy/', title: 'Confidentialité' },
        { href: 'https://au.wingie.com/fr/terms-and-conditions/', title: 'Conditions générales' },
        {
          href: 'https://au.wingie.com/fr/awards/',
          title: 'Nos récompenses',
        },
      ],
    },
  ],
  'au-pt': [
    {
      title: 'Mais',
      items: [
        { href: 'https://au.wingie.com/pt/contact/', title: 'Contacto' },
        // { href: 'https://au.wingie.com/pt/faq/', title: 'Perguntas frequentes' },
        { href: 'https://au.wingie.com/pt/about-us/', title: 'Sobre nós' },
        { href: 'https://au.wingie.com/pt/privacy/', title: 'Privacidade' },
        { href: 'https://au.wingie.com/pt/terms-and-conditions/', title: 'Termos e condições' },
        {
          href: 'https://au.wingie.com/pt/awards/',
          title: 'Nossos prêmios',
        },
      ],
    },
  ],
  'au-ro': [
    {
      title: 'Mai multe',
      items: [
        { href: 'https://au.wingie.com/ro/contact/', title: 'Contact' },
        // { href: 'https://au.wingie.com/ro/faq/', title: 'Întrebări frecvente' },
        { href: 'https://au.wingie.com/ro/about-us/', title: 'Despre noi' },
        { href: 'https://au.wingie.com/ro/privacy/', title: 'Confidențialitate' },
        { href: 'https://au.wingie.com/ro/terms-and-conditions/', title: 'Termeni și condiții' },
        {
          href: 'https://au.wingie.com/ro/awards/',
          title: 'Premiile noastre',
        },
      ],
    },
  ],
  'au-pl': [
    {
      title: 'Więcej',
      items: [
        { href: 'https://au.wingie.com/pl/contact/', title: 'Kontakt' },
        // { href: 'https://au.wingie.com/pl/faq/', title: 'Często zadawane pytania' },
        { href: 'https://au.wingie.com/pl/about-us/', title: 'O nas' },
        { href: 'https://au.wingie.com/pl/privacy/', title: 'Prywatność' },
        { href: 'https://au.wingie.com/pl/terms-and-conditions/', title: 'Regulamin' },
        {
          href: 'https://au.wingie.com/pl/awards/',
          title: 'Nasze nagrody',
        },
      ],
    },
  ],
  'au-lt': [
    {
      title: 'Daugiau',
      items: [
        { href: 'https://au.wingie.com/lt/contact/', title: 'Kontaktai' },
        // { href: 'https://au.wingie.com/lt/faq/', title: 'Dažnai užduodami klausimai' },

        { href: 'https://au.wingie.com/lt/about-us/', title: 'Apie mus' },
        { href: 'https://au.wingie.com/lt/privacy/', title: 'Privatumas' },
        { href: 'https://au.wingie.com/lt/terms-and-conditions/', title: 'Taisyklės ir sąlygos' },
        {
          href: 'https://au.wingie.com/lt/awards/',
          title: 'Mūsų apdovanojimai',
        },
      ],
    },
  ],
  'au-uz': [
    {
      title: "Ko'proq",
      items: [
        { href: 'https://au.wingie.com/uz/contact/', title: 'Aloqa' },
        // { href: 'https://au.wingie.com/uz/faq/', title: 'Tez-tez beriladigan savollar' },

        { href: 'https://au.wingie.com/uz/about-us/', title: 'Biz haqimizda' },
        { href: 'https://au.wingie.com/uz/privacy/', title: 'Maxfiylik' },
        { href: 'https://au.wingie.com/uz/terms-and-conditions/', title: 'Shartlar va qoidalar' },
        {
          href: 'https://au.wingie.com/uz/awards/',
          title: 'Bizning mukofotlarimiz',
        },
      ],
    },
  ],
  'au-sr': [
    {
      title: 'Više',
      items: [
        { href: 'https://au.wingie.com/sr/contact/', title: 'Kontakt' },
        // { href: 'https://au.wingie.com/sr/faq/', title: 'Često postavljana pitanja' },

        { href: 'https://au.wingie.com/sr/about-us/', title: 'O nama' },
        { href: 'https://au.wingie.com/sr/privacy/', title: 'Privatnost' },
        { href: 'https://au.wingie.com/sr/terms-and-conditions/', title: 'Uslovi korišćenja' },
        {
          href: 'https://au.wingie.com/sr/awards/',
          title: 'Naše nagrade',
        },
      ],
    },
  ],
  'au-ky': [
    {
      title: 'Көбүрөөк',
      items: [
        { href: 'https://au.wingie.com/ky/contact/', title: 'Байланыш' },
        // { href: 'https://au.wingie.com/ky/faq/', title: 'Көп берилүүчү суроолор' },

        { href: 'https://au.wingie.com/ky/about-us/', title: 'Биз жөнүндө' },
        { href: 'https://au.wingie.com/ky/privacy/', title: 'Купуялык' },
        { href: 'https://au.wingie.com/ky/terms-and-conditions/', title: 'Шарттар жана эрежелер' },
        {
          href: 'https://au.wingie.com/ky/awards/',
          title: 'Биздин мүҳофийлар',
        },
      ],
    },
  ],
  'au-tg': [
    {
      title: 'Зиёда',
      items: [
        { href: 'https://au.wingie.com/tg/contact/', title: 'Тамос' },
        // { href: 'https://au.wingie.com/tg/faq/', title: 'Саволҳои тез-тез пурсидашуда' },

        { href: 'https://au.wingie.com/tg/about-us/', title: 'Дар бораи мо' },
        { href: 'https://au.wingie.com/tg/privacy/', title: 'Махфият' },
        { href: 'https://au.wingie.com/tg/terms-and-conditions/', title: 'Шартҳо ва қоидаҳо' },
        {
          href: 'https://au.wingie.com/tg/awards/',
          title: 'Бизнинг мҳофийларимиз',
        },
      ],
    },
  ],
  'au-kk': [
    {
      title: 'Көбірек',
      items: [
        { href: 'https://au.wingie.com/kk/contact/', title: 'Байланыс' },
        // { href: 'https://au.wingie.com/kk/faq/', title: 'Жиі қойылатын сұрақтар' },

        { href: 'https://au.wingie.com/kk/about-us/', title: 'Біз туралы' },
        { href: 'https://au.wingie.com/kk/privacy/', title: 'Құпиялылық' },
        { href: 'https://au.wingie.com/kk/terms-and-conditions/', title: 'Шарттар мен ережелер' },
        {
          href: 'https://au.wingie.com/kk/awards/',
          title: 'Бизнинг мҳофийларимиз',
        },
      ],
    },
  ],
  'au-nl': [
    {
      title: 'Meer',
      items: [
        { href: 'https://au.wingie.com/nl/contact/', title: 'Contact' },
        // { href: 'https://au.wingie.com/nl/faq/', title: 'Veelgestelde vragen' },

        { href: 'https://au.wingie.com/nl/about-us/', title: 'Over ons' },
        { href: 'https://au.wingie.com/nl/privacy/', title: 'Privacy' },
        { href: 'https://au.wingie.com/nl/terms-and-conditions/', title: 'Algemene voorwaarden' },
        {
          href: 'https://au.wingie.com/nl/awards/',
          title: 'Onze prijzen',
        },
      ],
    },
  ],
  'au-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://au.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://au.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://au.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://au.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://au.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://au.wingie.com/ja/awards/' },
      ],
    },
  ],
  'au-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://au.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://au.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://au.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://au.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://au.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://au.wingie.com/zh/awards/' },
      ],
    },
  ],
  'au-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://au.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://au.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://au.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://au.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://au.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://au.wingie.com/ko/awards/' },
      ],
    },
  ],
  'au-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://au.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://au.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://au.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://au.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://au.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://au.wingie.com/hi/awards/' },
      ],
    },
  ],
  'au-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://au.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://au.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://au.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://au.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://au.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://au.wingie.com/ta/awards/' },
      ],
    },
  ],
  'au-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://au.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://au.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://au.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://au.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://au.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://au.wingie.com/th/awards/' },
      ],
    },
  ],
  'au-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://au.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://au.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://au.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://au.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://au.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://au.wingie.com/ur/awards/' },
      ],
    },
  ],
  'au-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://au.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://au.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://au.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://au.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://au.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://au.wingie.com/ka/awards/' },
      ],
    },
  ],
}
